/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import { MODAL_CLOSE } from '../modal/modalConstants';
import {
    FORM_ADDRESS_GET_AS_STRING_FAILURE,
    FORM_ADDRESS_GET_AS_STRING_START,
    FORM_ADDRESS_GET_AS_STRING_SUCCESS,
    FORM_ADDRESS_INITIALIZE,
    FORM_ADDRESS_SEARCH_FAILURE,
    FORM_ADDRESS_SEARCH_START,
    FORM_ADDRESS_SEARCH_SUCCESS,
    formAddressInitialState,
} from './constant/formAddressConstants';
import { TFormAddressActions } from './types/formAddressActionTypes';
import {
    EFormAddressField,
    IFormAddressConfiguration,
    TFormAddressSearchFoundItems,
    TFormAddressSearchIsLoading,
} from './types/formAddressTypes';

export interface IFormAddressReducer {
    addressConfiguration: IFormAddressConfiguration;
    isFormInit: boolean;
    searchFoundItems: TFormAddressSearchFoundItems;
    searchIsLoading: TFormAddressSearchIsLoading;
}

const formAddressReducer: Reducer<IFormAddressReducer, TFormAddressActions> =
    (state = formAddressInitialState, action: TFormAddressActions) =>
        produce(state, draft => {
            switch (action.type) {
                /* Form Initialize */
                case FORM_ADDRESS_INITIALIZE:
                    draft.isFormInit = true;
                    draft.addressConfiguration.airId = action.payload.address.addressId;
                    draft.addressConfiguration.addressId = action.payload.address.addressId;
                    draft.addressConfiguration.addressString = action.payload.address.addressString;
                    // ЭПС по умолчанию не выбран
                    draft.addressConfiguration[EFormAddressField.planningElementOptional] = true;
                    break;

                /* Search for Address Matches */

                case FORM_ADDRESS_SEARCH_START:
                    draft.searchIsLoading = { [action.payload.type]: true };
                    draft.searchFoundItems = {};
                    break;
                case FORM_ADDRESS_SEARCH_SUCCESS:
                    draft.searchIsLoading = {};
                    draft.searchFoundItems = action.payload.searchItems;
                    break;
                case FORM_ADDRESS_SEARCH_FAILURE:
                    draft.searchIsLoading = {};
                    break;

                /* Get Address as String */

                case FORM_ADDRESS_GET_AS_STRING_SUCCESS:
                    draft.addressConfiguration.addressString = action.payload.addressString;
                    break;
                case FORM_ADDRESS_GET_AS_STRING_START:
                case FORM_ADDRESS_GET_AS_STRING_FAILURE:
                    break;

                case MODAL_CLOSE:
                    Object.assign(draft, formAddressInitialState);
                    break;
            }
        });

export default formAddressReducer;
